var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.isProgressbarVisible)?_c('div',{staticClass:"vue-progress",class:{ 'active': _vm.progress }},[_c('div',{staticClass:"item loading-6"},[_c('svg',{attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"20"}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }